import React from "react";

export const b64_to_utf8 = (b64: string): string =>
  decodeURIComponent(escape(window.atob(b64)));

export const current = <T>(ref: React.MutableRefObject<T>): T => ref.current;

export const noop = (..._args: any[]): any => {};

export const utf8_to_b64 = (utf8: string): string =>
  window.btoa(unescape(encodeURIComponent(utf8)));

export const sToDhms = (seconds: number): string => {
  const date = new Date(seconds * 1000).toISOString();
  const days = date.substring(8, 10);
  const hms = date.substring(11, 19);

  return `${Number(days) - 1 ? Number(days) - 1 + "j" : ""} ${hms}`;
};
